import { env } from '@/helpers';

export default {
  getToken(): Promise<string | null> {
    const grecaptchaKey = env('GRECAPTCHA_KEY');
    const hasGrecaptchaKey = !!grecaptchaKey;

    return new Promise((resolve, reject) => {
      if (!hasGrecaptchaKey) {
        resolve(null);
      }

      if (!window.grecaptcha) {
        reject(new Error('grecaptcha not initialized'));
      }

      window.grecaptcha.ready(() => {
        if (typeof grecaptchaKey === 'number') {
          window.grecaptcha.execute(grecaptchaKey, { action: 'submit' }).then((token: string) => {
            resolve(token);
          }).catch(() => {
            reject(new Error('cant fetch token'));
          });
        } else {
          reject(new Error('non numeric token'));
        }
      });
    });
  },
};
